/**
 * Converts a rgba color string to RGB components.
 * @param {string} rgba The rgba color string.
 * @return {number[]} The [r, g, b] components.
 */
export function rgbaToRgb(rgba) {
  const rgbaRegExp = /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)$/i;
  const result = rgbaRegExp.exec(rgba);
  if (!result) {
    console.error('Invalid rgba color format');
    return [];
  }

  const [, r, g, b] = result.map(Number);
  return [r, g, b];
}
